// extracted by mini-css-extract-plugin
export default {"Logo":"LoginForm_Logo__Dtc8m"};